import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import qs from 'qs'
import './plugins/element.js'
//导入字体图标
import './assets/fonts/iconfont.css'
//导入全局样式表
import './assets/css/global.css'
import moment from 'moment'
import 'lib-flexible'
import htmlToPdf from './utils/htmlToPdf'
import axios from 'axios'
import { cloud, local } from './config/index';

Vue.prototype.$moment = moment
Vue.prototype.$path = cloud.path; //'http://120.46.209.88:5173/#/login' //IDM登录界面
Vue.prototype.$port = cloud.port; //'http://120.46.209.88:5173/#/portalhome' //IDM门户页
Vue.prototype.$qian = cloud.qian; //'http://120.46.209.88:3455/#/' //WMS前端自跳转
Vue.prototype.$IDMapi = cloud.IDMapi; //'http://120.46.209.88:8113/WMS/redirect' //idm接口

Vue.use(htmlToPdf)
Vue.prototype.$axios = axios
//配置请求的根路径
axios.defaults.baseURL = cloud.baseURL; //'http://120.46.209.88:8113'//wms后端接口前缀

/* API V1 认证统一使用 Token 认证
需要授权的 API ，必须在请求头中使用 `Authorization` 字段提供 `token` 令牌 */
//axios请求拦截
axios.interceptors.request.use(config => {
  //为请求头对象，添加Token验证的Authorization字段
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})
Vue.prototype.$http = axios
Vue.prototype.$qs = qs
Vue.config.productionTip = false

Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
